import { css, cx } from "@emotion/css"

const styles = {
  root: css`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  `,
  line: css`
    display: flex;
    flex-direction: column;
    height: 3px;
    width: 150px;
  `,
  legend: css`
    color: var(--white);
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
  `,
  number: css`
    font-size: 12px;
    font-weight: 400;
  `,
  title: css`
    font-weight: 900;
    font-size: 12px;
    font-weight: 200;
  `,
  label: css`
    width: 20px;
    color: var(--white);
    font-weight: bold;
    font-size: 13px;
    text-align: center;
  `,
  dotContainer: ({ left }: { left: number }) => css`
    border: 0;
    margin: 0;
    position: absolute;
    bottom: 20px;
    left: ${left}px;
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  dot: css`
    width: 9px;
    height: 9px;
    margin-top: 4px;
    background-color: var(--tertiary-lighter-yellow);
    border-radius: 50%;
    box-shadow: 0 0 0 3px var(--primary-main-light-green);
  `,
}

interface propsTypes {
  title?: string
  className?: string
  percentage?: number
  label?: string
  rate?: number
  minRange?: string
  maxRange?: string
  range: number
}
export function ProgressBarDot(props: propsTypes) {
  const { title, label, rate, minRange, maxRange, range } = props

  const showRates = !!rate || rate === 0

  return (
    <div className={styles.root}>
      <div>
        {showRates ? (
          <>
            <div
              className={styles.line}
              style={{
                background: "linear-gradient(to right, red, #eee8aa, green)",
                backgroundImage:
                  "linear-gradient(to right, red, #eee8aa, green)",
              }}
            ></div>
          </>
        ) : (
          <hr
            className={styles.line}
            style={{
              width: "145px",
              height: "8px",
              border: "1px solid #0d0d0d",
              background: "#0d0d0d",
            }}
          ></hr>
        )}
        <div className={styles.legend}>
          <span className={cx("HeadingH5bBold", styles.number)}>
            {minRange}
          </span>
          <div className={styles.title}>{title}</div>
          <span className={cx("HeadingH5bBold", styles.number)}>
            {maxRange}
          </span>
        </div>
      </div>
      {showRates && (
        <div
          className={styles.dotContainer({
            left: ((rate! - 10) * 150) / range,
          })}
        >
          <span className={styles.label}>{`${label}`}</span>
          <div className={styles.dot} />
        </div>
      )}
    </div>
  )
}
